var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewsletterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H3a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V3a3 3 0 00-3-3zm0 2l-6.5 4.47a1 1 0 01-1 0L3 2h14z",
    fill: "url(#newsletterIcon_svg__paint0_linear_7212_228)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "newsletterIcon_svg__paint0_linear_7212_228",
    x1: 20,
    y1: 16,
    x2: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#98D3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#92E1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DECE0"
  })))));
}

export default SvgNewsletterIcon;